// LoginPage.tsx — sign-in via the shared OidcLoginPage. The page
// auto-redirects to /api/oidc/login, the lib/oidcrp handler runs the
// authz round-trip, sets the session cookie, and bounces back to "/".
import { OidcLoginPage } from 'common';

export default function LoginPage() {
    return <OidcLoginPage issuerLabel="authz.lab0.us" returnTo="/" />;
}
